// Models
import { UserStateModel } from '@app/models/user.model';

export class SetUser {
  static readonly type = '[SetUser] action';
  constructor(readonly payload: UserStateModel) {}
}
